import { IApplicationState, TBoardId } from 'app/types/types';
import { IAppTab } from '../tabs/types';

export const getTabBoard = (
    state: IApplicationState,
    boardId: TBoardId
): IAppTab => {
    return state.model.tabs[boardId];
};
